
import Node, { NodeLinkedMenu, NodeApplication, NodeInfo } from './redux/model/Node';
import NodePreview from './redux/model/NodePreview';
import RSS from './redux/model/RSS';
import GenericMediaItem from './redux/model/GenericMediaItem';
import GenericQRCaster from './redux/model/GenericQRCaster';
import MediaGrid from './redux/model/MediaGrid';
import Movie from './redux/model/Movie';
import Radio from './redux/model/Radio';
import RemoteSiteLauncher from './redux/model/RemoteSiteLauncher';
import ServiceCall from './redux/model/ServiceCall';
import SlideShow from './redux/model/SlideShow';
import StartInactiveBrowser from './redux/model/StartInactiveBrowser';
import TVApp from './redux/model/TVApp';
import Weather from './redux/model/Weather';
import { cloneDeep } from 'lodash';

export const LIMIT_UPLOAD_FILE_SIZE = 1024 * 1024 * 100 //100MB

export const ROLE = {
    STAFF: 5,
}

export const DEVICE_AUTHENTICATION_LIST = [
    { id: 1, value: 'Hardware Serial' },
    { id: 2, value: 'Device Token' },
    { id: 3, value: 'Device Secret' },
    { id: 4, value: 'Client Session' },
    { id: 5, value: 'Client Token' },
    { id: 6, value: 'Unknown or None' }
]

export const RECURRENCE = {
    DAILY: 'Daily',
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
};

export const MESSAGES_TYPE = {
    INBOX: 'INBOX',
    SENT: 'SENT',
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED'
};

export const FONT_SIZE = {
    SMALL: 7,
    MEDIUM: 10,
    LARGE: 13
};

export const FONT_SIZE_LABEL = {
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large'
};

export const RECEIVER_TYPE = {
    USER: 'User',
    ENTITY: 'Entity',
    GROUP: 'Group',
    CLUSTER: 'Cluster',
    INDIVIDUALS: 'Individuals'
};

export const DEFAULT_MESSAGE_TEMPLATE = {
    id: -1,
    name: 'None',
    subject: '',
    message: '',
    dyslexie: false,
    expiration: 0,
    fontSize: 13,
    messageType: 0,
    priorityType: 0,
    scheduleType: 0,
};

export const DEFAULT_ALARM_TEMPLATE = {
    id: -1,
    name: 'None',
    subject: '',
    message: '',
    dyslexie: false,
    expirationType: 0,
    fontSize: 13,
    scheduleType: 0,
    tone: {
        name: 'None',
        fd: ''
    }
};

export const SCHEDULE_TYPE = {
    IMMEDIATELY: 0,
    OTHER: 1,
    SCHEDULE_TEMPLATE: 2
};

export const EXPIRATION_TYPE = {
    NONE: 0,
    DAY_TIME: 1,
};

export const NODE_NAMES = {
    INFO: 'Info',
    APPLICATION: 'Application',
    LINKED_MENU: 'Linked Menu',
    CONTACT: 'Contact',
    MESSAGE: 'Message',
    SCHEDULE: 'Schedule',
    AUDIO: 'Audio',
};

export const INFO_PAGE_APP_FUNCTIONS = {
    TV_MODE: 1,
    GENERIC_MEDIA: 2,
    RADIO: 3,
    WEATHER: 4,
    SERVICE_CALL: 5,
    SLIDE_SHOW: 6,
    RSS: 7,
    LAUNCH_TV_APP: 8,
    PLAY_MOVIE: 9,
    START_INACTIVE_BROWSER: 10,
    GENERIC_QR_CASTER: 11,
    MEDIA_GRID: 12,
    REMOTE_SITE_LAUNCHER: 13,
    LAUNCH_USB: 14,
    SLEEPER_TIMER: 15,
    STOP_WATCH: 16,
    WAKE_UP_CALL: 17,
    EXTERNAL_SERVICES: 18,
    // CHILD_LOCK: 18
};

export const LIST_APPLICATION_FUNCTIONS = [
    { id: INFO_PAGE_APP_FUNCTIONS.TV_MODE, label: 'resources.infoPage.tv_mode' },
    { id: INFO_PAGE_APP_FUNCTIONS.LAUNCH_TV_APP, label: 'resources.infoPage.launch_tv_app' },
    { id: INFO_PAGE_APP_FUNCTIONS.GENERIC_MEDIA, label: 'resources.infoPage.generic_media' },
    { id: INFO_PAGE_APP_FUNCTIONS.PLAY_MOVIE, label: 'resources.infoPage.play_movie' },
    { id: INFO_PAGE_APP_FUNCTIONS.START_INACTIVE_BROWSER, label: 'resources.infoPage.start_inactive_browser' },
    { id: INFO_PAGE_APP_FUNCTIONS.LAUNCH_USB, label: 'resources.infoPage.launch_usb' },
    { id: INFO_PAGE_APP_FUNCTIONS.GENERIC_QR_CASTER, label: 'resources.infoPage.generic_qr_caster' },
    { id: INFO_PAGE_APP_FUNCTIONS.MEDIA_GRID, label: 'resources.infoPage.media_grid' },
    { id: INFO_PAGE_APP_FUNCTIONS.RADIO, label: 'resources.infoPage.radio' },
    { id: INFO_PAGE_APP_FUNCTIONS.REMOTE_SITE_LAUNCHER, label: 'resources.infoPage.remote_site_launcher' },
    { id: INFO_PAGE_APP_FUNCTIONS.RSS, label: 'resources.infoPage.rss' },
    { id: INFO_PAGE_APP_FUNCTIONS.SERVICE_CALL, label: 'resources.infoPage.service_call' },
    { id: INFO_PAGE_APP_FUNCTIONS.SLEEPER_TIMER, label: 'resources.infoPage.sleeper_timer' },
    { id: INFO_PAGE_APP_FUNCTIONS.SLIDE_SHOW, label: 'resources.infoPage.slide_show' },
    { id: INFO_PAGE_APP_FUNCTIONS.STOP_WATCH, label: 'resources.infoPage.stop_watch' },
    { id: INFO_PAGE_APP_FUNCTIONS.WAKE_UP_CALL, label: 'resources.infoPage.wake_up_call' },
    { id: INFO_PAGE_APP_FUNCTIONS.WEATHER, label: 'resources.infoPage.weather' },
    { id: INFO_PAGE_APP_FUNCTIONS.EXTERNAL_SERVICES, label: 'resources.infoPage.external_services' },
    // { id: INFO_PAGE_APP_FUNCTIONS.CHILD_LOCK, label: 'resources.infoPage.child_lock' },
];

export const GENERIC_MEDIA_ITEM_INPUT = {
    HDMI_1: 0,
    HDMI_2: 1,
    HDMI_3: 2,
    USB: 3,
    INFO_CHANNEL: 4,
    MEDIA_FILE: 5
};
export const GENERIC_QR_CASTER_DEVICE = [
    { id: 1, name: 'HDMI' }
];


export const LIST_INPUT = [
    { id: GENERIC_MEDIA_ITEM_INPUT.HDMI_1, label: 'resources.infoPage.genericMedia.hdmi_1', qrCasterOnly: true },
    { id: GENERIC_MEDIA_ITEM_INPUT.HDMI_2, label: 'resources.infoPage.genericMedia.hdmi_2', qrCasterOnly: true },
    { id: GENERIC_MEDIA_ITEM_INPUT.HDMI_3, label: 'resources.infoPage.genericMedia.hdmi_3', qrCasterOnly: true },
    { id: GENERIC_MEDIA_ITEM_INPUT.USB, label: 'resources.infoPage.genericMedia.usb' },
    { id: GENERIC_MEDIA_ITEM_INPUT.INFO_CHANNEL, label: 'resources.infoPage.genericMedia.info_channel' },
    { id: GENERIC_MEDIA_ITEM_INPUT.MEDIA_FILE, label: 'resources.infoPage.genericMedia.media_file' },
];

export const headChannelCells = [
    { id: 'checkmark', numeric: false, disablePadding: false, label: '', sortable: false },
    { id: 'logo', numeric: false, disablePadding: true, label: 'Logo', sortable: false },
    { id: 'number', numeric: true, disablePadding: false, label: 'Number', sortable: true },
    { id: 'type', numeric: false, disablePadding: false, label: 'Type', sortable: true },
    { id: 'name', numeric: false, disablePadding: true, label: 'Name', sortable: true },
    { id: 'internalName', numeric: false, disablePadding: false, label: 'Internal-Name', sortable: true },
    { id: 'epgId', numeric: false, disablePadding: false, label: 'Epg-id', sortable: true }
];

export const headExternalDeviceCells = [
    { id: 'checkmark', numeric: false, disablePadding: false, label: '', sortable: false },
    { id: 'clientId', numeric: false, disablePadding: true, label: 'Client ID', sortable: true },
    { id: 'macAddressBox', numeric: false, disablePadding: true, label: 'MacAddress Box', sortable: true },
];

export const resolutions = [
    { width: 960, height: 540 },
    { width: 1280, height: 720 },
    { width: 1920, height: 1080 },
    { width: 3840, height: 2160 },
    { width: 7680, height: 4320 }
];

export const WIFI_ENCRYPTION_TYPES = [
    { id: 1, name: 'No Encryption' },
    { id: 2, name: 'WPA/WPA2' },
    { id: 3, name: 'WEP' },
];

export const INFO_PAGE_DIALOG = {
    DEFAULT: '',
    CREATE: 'CREATE',
    RENAME: 'RENAME',
    CLONE: 'CLONE'
};

export function getTemplateInterval(data: any) {
    var result = {}
    switch (data) {
        case 'Daily':
            result = { value: data, name: RECURRENCE.DAILY };
            break;
        case 'Weekly':
            result = { value: data, name: RECURRENCE.WEEKLY };
            break;
        case 'Monthly':
            result = { value: data, name: RECURRENCE.MONTHLY };
            break;
        default:
            break;
    }
    return result;
}

export function getDateMonth(timestamp: number, isSchedule: boolean) {
    const dateNow = new Date().getTime();
    const date = new Date(timestamp);
    const dateNew = date.getTime();

    const checkdate = dateNow - dateNew;

    if (checkdate < 3600000) {
        const minutes = Math.floor(checkdate / 60000);
        return isSchedule ? minutes + " minutes" : minutes + " minutes ago";
    } else if (checkdate < 86400000) {
        const hours = Math.floor(checkdate / (1000 * 60 * 60))
        return isSchedule ? hours + " hours" : hours + " hours ago";
    }
    else {
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return day + ' ' + months[date.getMonth()];
    }
}

export function getTimeDayMonth(timestamp: any, translate: any) {
    switch (timestamp && timestamp.type) {
        case 'minutes':
            if (timestamp.minutes === 0) {
                const minute = `${translate('pos.messages.justNow')}`
                return minute
            }
            else if (timestamp.minutes < 2) {
                const minute = `${timestamp.minutes} ${translate('pos.messages.minute')}`
                return minute
            } else {
                const minutes = `${timestamp.minutes} ${translate('pos.messages.minutes')}`
                return minutes
            }
        case 'hours':
            if (timestamp.hours < 2) {
                const hour = `${timestamp.hours} ${translate('pos.messages.hour')}`
                return hour
            } else {
                const hours = `${timestamp.hours} ${translate('pos.messages.hours')}`
                return hours
            }
        case 'day':
            const months = [`${translate('pos.messages.January')}`, `${translate('pos.messages.February')}`, `${translate('pos.messages.March')}`,
            `${translate('pos.messages.April')}`, `${translate('pos.messages.May')}`, `${translate('pos.messages.June')}`,
            `${translate('pos.messages.July')}`, `${translate('pos.messages.August')}`, `${translate('pos.messages.September')}`,
            `${translate('pos.messages.October')}`, `${translate('pos.messages.November')}`, `${translate('pos.messages.December')}`];
            return `${timestamp.days} ${months[timestamp.month]}`
    }
}

export function getTimeUpLoad(timestamp: number) {
    const date = new Date(timestamp);
    const getArrayMonth = parseInt(String(date.getMonth())) + 1;
    const month = getArrayMonth < 10 ? '0' + getArrayMonth : getArrayMonth;
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();

    return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' + minute;
}

export function isImage(ext: string | undefined) {
    const extensions = ['jpeg', 'jpg', 'png', 'gif', 'tiff'];
    if (!ext) return false;
    return extensions.indexOf(ext.toLowerCase()) > -1;
}

export function isVideo(ext: string | undefined) {
    const extensions = ['mp4', '3gp', 'ogg', 'wmv', 'webm', 'flv', 'avi', 'mov'];
    if (!ext) return false;
    return extensions.indexOf(ext.toLowerCase()) > -1;
}

export function isAudio(ext: string | undefined) {
    const extensions = ['mp3', 'wma', 'aac', 'wav', 'flac'];
    if (!ext) return false;
    return extensions.indexOf(ext.toLowerCase()) > -1;
}

export function isMedia(ext: string | undefined) {
    return isAudio(ext) || isVideo(ext)
}

/** 
 * Return: Mon 6/1/2020 1:30
*/
export function getFullTime(timestamp: number) {
    const date = new Date(timestamp);
    const dayOfWeeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];

    const dayOfWeek = dayOfWeeks[date.getDay()];
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();;

    return `${dayOfWeek} ${month}/${day}/${year} ${hour}:${minute}`
}

export function getDayMonthYear(timestamp: number) {
    const date = new Date(timestamp);
    const getArrayMonth = parseInt(String(date.getMonth())) + 1;
    const month = getArrayMonth < 10 ? '0' + getArrayMonth : getArrayMonth;
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const year = date.getFullYear();
    return `${day}/${month}/${year}`
}

export function isFileNameExisted(files: Array<any>, name: string) {
    if (Array.isArray(files)) {
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.name.trim() === name.trim()) return true;
        }
    }
    return false;
}

/** 
 * Return new array
*/
export function sortCategories(array = [], field: string, order: string) {
    switch (field) {
        case 'name':
            return array.sort((a: any, b: any) => {
                if (order === 'ASC') return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
                return a.name.toUpperCase() < b.name.toUpperCase() ? 1 : -1;
            });
        case 'type':
            return array.sort((a: any, b: any) => {
                if (order === 'ASC') return a.type.toUpperCase() > b.type.toUpperCase() ? 1 : -1;
                return a.type.toUpperCase() < b.type.toUpperCase() ? 1 : -1;
            });
        case 'size':
            return array.sort((a: any, b: any) => {
                if (order === 'ASC') return a.size > b.size ? 1 : -1;
                return a.size < b.size ? 1 : -1;
            });
        case 'createdAt':
            return array.sort((a: any, b: any) => {
                if (order === 'ASC') return a.createdAt > b.createdAt ? 1 : -1;
                return a.createdAt < b.createdAt ? 1 : -1;
            });
        default:
            break;
    }
}


/** 
 * INPUT: filesize as byte
 * Return: 25kb | 2mb
*/
export function getFileSizeStr(filesize: number) {
    if (filesize < 1024) {
        return filesize + ' b';
    } else if (filesize < 1024 * 1024) {
        return Math.ceil(filesize / 1024) + ' kb';
    }
    return Math.ceil(filesize / (1024 * 1024)) + ' mb';
}

/** 
 * INPUT: name: 'my_file' | 'my_file.txt'
 * OUTPUT: 'my_file'
*/
export function getFileNameWithoutExtension(name: string) {
    const names = name.split('.');
    if (names.length <= 1) {
        return name;
    }
    names.pop();
    return names.join('.');
}

/** 
 * Params: cls means "Cluster"
 * Should return true or false
*/
export const shouldBeDisabled = (cls: any) => {
    if ((cls.functionId === 25 && cls.isCreate === false) || (cls.functionId === 27 && cls.isCreate === false))
        return false;
    else {
        if ((cls.functionId === 24 && cls.isCreate === true) || (cls.functionId === 26 && cls.isCreate === true)) return false;
    }
    return true
}
/** 
 * Params: cls means "Cluster"
 * Should return true or false
*/
export const shouldBeDisabledCreate = (cls: any) => {
    if ((cls.id === 25 && cls.isCreate === false) || (cls.id === 27 && cls.isCreate === false))
        return false;
    else {
        if ((cls.id === 24 && cls.isCreate === true) || (cls.id === 26 && cls.isCreate === true)) return false;
    }
    return true
}

export const convertPriorityText = (number: number) => {
    return number === 0 ? 'Critical' : 'Normal';
}

export const convertMessageTypeText = (number: number) => {
    return number === 1 ? 'Pop-up' : 'Notification banner';
}

export const convertScheduleTypeText = (number: number) => {
    if (number === 0) return 'Immediately';
    if (number === 1) return 'Other';
    return 'Schedule template';
}

export const convertExpirationTypeText = (number: number) => {
    return number === 1 ? 'None' : 'Day/time';
}

export const getTextPagination = (messages = [], pagination: any, totalItems: any, translate: any) => {
    if (messages.length === 0) {
        return `0-0 ${translate('resources.alarm.of')} 0`;
    }
    const start = (pagination.page - 1) * pagination.perPage + 1;
    const end = (pagination.page - 1) * pagination.perPage + messages.length;
    return `${start}-${end} ${translate('resources.alarm.of')} ${totalItems}`;
}

export const getListIdsSaveAsDraft = (receiver: string, right = []) => {
    switch (receiver) {
        case RECEIVER_TYPE.USER:
            return right.map((item: any) => item.id);
        case RECEIVER_TYPE.ENTITY:
            return right.map((item: any) => item.name);
        case RECEIVER_TYPE.GROUP:
            return right.map((item: any) => item.entity + ' - ' + item.name);
        case RECEIVER_TYPE.CLUSTER:
            return right.map((item: any) => item.id);
        default:
            // Individuals (Room)
            const roomIds: any[] = [];
            right.forEach((cluster: any) => {
                cluster.rooms.forEach((room: any) => roomIds.push(room.id));
            });
            return roomIds;
    }
}

export const trimSubjectStr = (subject: string, content: string, isDraft: boolean) => {
    if (!isDraft) {
        var trimText = content.trim()
        if (subject === "") {
            var text = ""
            for (let i = 0; i < trimText.length; i++) {
                if (i > 50)
                    break
                else {
                    text += trimText.charAt(i)
                }
            }
            var newSubject = ""
            for (let i = 0; i < text.length; i++) {
                if (!(text.charAt(i).match(/\n/))) {
                    newSubject += text.charAt(i)
                }
                else
                    break
            }
            return `${newSubject}...`;
        }
    }
    return subject;
}

export const generateRandomString = (length: number) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const buildingTreeNode = (data: any[] = []) => {
    for (let i = 0; i < data.length; i++) {
        data[i].isShowNameInput = false;
        data[i].code = data[i].code;
        data[i].applicationData = JSON.parse(data[i].applicationData);
    }
    data.sort((a, b) => b.parentMenu - a.parentMenu);

    for (let i = 0; i < data.length - 1; i++) {
        const item = data[i];

        for (let j = i + 1; j < data.length; j++) {
            if (item.parentMenu === data[j].id) {
                if (!data[j].children) {
                    data[j].children = [];
                }
                data[j].children.push(item);
                break;
            } else {

            }
        }
    }

    return data.filter(item => item.parentMenu === null);
}

export const dispatchTree = (data = [], translate: any) => {
    return data.map((item: any) => {
        return {
            id: item.id,
            language: item.language,
            expand: false,
            active: item.active,
            isShowNameInput: false,
            expandIds: [],
            children: [
                {
                    id: 'main_' + item.id,
                    nodeName: translate('resources.infoPage.treeMain'),
                    expand: false,
                    children: buildingTreeNode(item.treeData),
                    isShowNameInput: false,
                    code: item.code,
                    data: {
                        timezone: item.timezone,
                        formatDateTime: item.formatDateTime,
                        weather: item.weather,
                        textSize: item.textSize,
                        backgroundImage: item.backgroundImage ? JSON.parse(item.backgroundImage) : null,
                        logoType: item.logoType ? JSON.parse(item.logoType) : null,
                        instructionVideo: item.instructionVideo ? JSON.parse(item.instructionVideo) : null,
                        instructionFeatureImage: item.instructionFeatureImage ? JSON.parse(item.instructionFeatureImage) : null,
                        rssLink: item.rssLink,
                        dyslexie: item.dyslexie
                    }
                }
            ],
        };
    });
}

export const getDimensions = async (filePath: string, fileType: string | undefined) => {
    return new Promise((resolve) => {
        try {
            if (isImage(fileType)) {
                const img = new Image();
                img.onload = function () {
                    resolve({ width: (this as any).width, height: (this as any).height });
                }
                img.onerror = function () {
                    resolve({ width: '100', height: '100' })
                }
                img.src = filePath;
            }
            if (isVideo(fileType)) {
                let video = document.createElement('video')
                video.preload = 'metadata'
                video.onloadedmetadata = function () {
                    resolve({ width: (this as any).videoWidth, height: (this as any).videoHeight })
                }
                video.onerror = function () {
                    resolve({ width: '100', height: '100' })
                }
                video.src = filePath
            }
        } catch (e) {
            resolve({ width: '100', height: '100' })
        }
    })
}

export const calcuMediaWidth = (dimension: any, screenSize: any, pivot: boolean, rotate: any, noprescaling: boolean) => {
    const width = pivot ? dimension.height : dimension.width, height = pivot ? dimension.width : dimension.height;
    const screenSizeW = screenSize.width, screenSizeH = screenSize.height;
    console.log('calcuMediaWidth:', width, height);
    const rate = 16 / 9;
    const hwRatio = (width / height) >= rate;
    if (!noprescaling) {
        return '100%';
    }
    else {
        if (!hwRatio)
            return 'auto';
        return (screenSizeW) + 'px';
        // else if(rotate % 180 > 0)
        //     return (screenSizeW)  + 'px';
        // else
        //     return (screenSizeH) + 'px';
    }
}

export const calcuMediaHeight = (dimension: any, screenSize: any, pivot: boolean, rotate: any, noprescaling: boolean) => {
    const width = pivot ? dimension.height : dimension.width, height = pivot ? dimension.width : dimension.height;
    const screenSizeW = screenSize.width, screenSizeH = screenSize.height;
    console.log('calcuMediaHeight:', width, height);
    const rate = 16 / 9;
    const hwRatio = (width / height) >= rate;
    if (!noprescaling) {
        return '100%';
    }
    else {
        if (hwRatio) {
            // if (pivot)
            //     return (screenSizeH) + 'px';
            return 'auto';
        }
        return (screenSizeH) + 'px';
        // else if(rotate % 180 > 0)
        //     return (screenSizeH) + 'px';
        // else
        //     return (screenSizeW) + 'px';
    }
}

export const findColor = (colors: Array<any>, colorValue: any) => {
    const color = colors.find(color => color.Value === colorValue);
    return color ? color : { Name: '', Value: '' };
}


export const getDefaultNodeInfo = () => {
    return {};
}

export const getDefaultLinkedMenu = () => {
    const nodeLinkedMenu = new NodeLinkedMenu();
    return nodeLinkedMenu;
}

export const getDefaultNodeInfoData = () => {
    const nodeInfo = new NodeInfo();
    return nodeInfo;
}

export const getDefaultNodeApplication = () => {
    const app: any = new NodeApplication();
    app.func = null;
    app.Rss = new RSS();
    app.genericMediaItem = new GenericMediaItem();
    app.genericQRCaster = new GenericQRCaster();
    app.mediaGrid = new MediaGrid();
    app.movie = new Movie();
    app.nodePreview = new NodePreview();
    app.radio = new Radio();
    app.remoteSiteLauncher = new RemoteSiteLauncher();
    app.serviceCall = new ServiceCall();
    app.slideShow = new SlideShow();
    app.startInactiveBrowser = new StartInactiveBrowser();
    app.tvApp = new TVApp();
    app.weatherLocation = new Weather();
    return app;
}

export const getDefaultNode = () => {
    const node: any = new Node();

    node.preview = new NodePreview();
    node.nodeType = NODE_NAMES.INFO;
    node.nodeApplication = getDefaultNodeApplication();
    node.nodeLinkedMenu = getDefaultLinkedMenu();
    node.NodeInfo = getDefaultNodeInfoData();
    return node;
}

export const changeTreeLeaf = (tree: any[] = [], id: number | string, data: any) => {
    const recursive = (node: any) => {
        const children = node.children ? node.children : [];

        for (let i = 0; i < children.length; i++) {
            if (children[i].id === id) {
                children[i].applicationData = data;
                break;
            } else {
                recursive(children[i]);
            }
        }
    }

    for (let i = 0; i < tree.length; i++) {
        recursive(tree[i].children[0]);
    }
    return tree;
}

let _instance: any;
export const SpotLightWrapper = (spotlightObj: any, boundLeftLength: any, maxItem: any, selectedIndex: any, instructionItem = '', idPrefix = '') => {
    //console.log('spotlightObj', spotlightObj);
    _instance = {
        idPrefix: idPrefix === '' ? 'SpotlightItem_' : idPrefix,
        spotlight: spotlightObj,
        boundLeftLength: boundLeftLength,
        maxItem: maxItem,
        instructionElementId: instructionItem,
        selectedIndex: selectedIndex
    };
    _instance.spotlight.focus(`[id="${_instance.idPrefix}${selectedIndex}"]`);
    return _instance;
}

export const handleSpotlightRight = (e: any) => {
    const crrIdx = getIndex(e);
    console.log('handleSpotlightRight', crrIdx);
    if (crrIdx === _instance.boundLeftLength) {
        const next = _instance.boundLeftLength + 1;
        e.preventDefault();
        e.stopPropagation();
        _instance.spotlight.focus(`[id="${_instance.idPrefix}${next}"]`);
    }
};

export const handleSpotlightLeft = (e: any) => {
    const next = _instance.boundLeftLength + 1;
    const crrIdx = getIndex(e);
    console.log('handleSpotlightLeft', crrIdx);
    if (crrIdx === next) {
        e.preventDefault();
        e.stopPropagation();
        _instance.spotlight.focus(`[id=${_instance.idPrefix}${_instance.boundLeftLength}]`);
    }
};

export const handleSpotlightDown = (e: any) => {
    console.log('handleSpotlightDown', _instance.selectedIndex);
    const isBottom = isBottomGrid(_instance.selectedIndex);
    if (isBottom && _instance.instructionElementId !== '') {
        // document.getElementById(String(_instance.instructionElementId))?.focus();
    }
};

export const isBottomGrid = (sIdx: any) => {
    const boundStartWith1 = _instance.boundLeftLength + 1;
    let totalRow = Math.ceil(_instance.maxItem / boundStartWith1);
    console.log('isBottomGrid', totalRow, boundStartWith1, _instance.maxItem, sIdx);
    return (totalRow === 1 || (totalRow - 1) * boundStartWith1 <= sIdx && sIdx + 1 <= totalRow * boundStartWith1);
}

export const getIndex = (e: any) => {
    return parseInt(e.target.id.replace(_instance.idPrefix, ''))
};



export const loadVideo = (url: any) => new Promise((resolve, reject) => {

    let video = document.createElement('video')
    video.preload = 'metadata'

    video.onloadedmetadata = function () {
        resolve(this)
    }

    video.onerror = function () {
        reject()
    }

    video.src = url
}).catch(e => {
    return false
});

export function convertSecondToPlayTime(seconds: number) {
    let hour: string | number = Math.floor(seconds / 3600);
    let minute: string | number = Math.floor((seconds - hour * 3600) / 60);
    let second: string | number = seconds - (hour * 3600 + minute * 60);

    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;
    if (second < 10) second = '0' + second;
    return hour + ':' + minute + ':' + second;
};

export const getFilterInfoPageName = (infoPages: any[] = [], id: string | number) => {
    const infoPage = infoPages.find(item => item.id === id);
    if (infoPages.length === 0 || !infoPage) return '';
    return infoPage.name;
}

export const getFilterInfoPage = (infoPages = [], id: string | number) => {
    console.log('getInfoPageName:', infoPages, id);
    const infoPage = infoPages.filter((item: any) => item.id !== id);
    if (infoPage.length === 0 || !infoPage) return [];
    return infoPage;
}

export const getLanguageName = (languages = [], infoPageLangId: string | number) => {
    const language: any = languages.find((item: any) => item.infoPageLanguageId === infoPageLangId);
    if (languages.length === 0 || !language) return '';
    return language.name;
}

export const getTVMenuName = (tvMenus = [], menuId: string | number) => {
    const tvMenu: any = tvMenus.find((item: any) => item.id === menuId);
    if (tvMenus.length === 0 || !tvMenu) return '';
    return tvMenu.nodeName;
}

export const markSelectedLeaf = (array: any[], id: string | number) => {
    const clone = cloneDeep(array);

    const setDefaultSelected = function (array: any[]) {
        for (let i = 0; i < array.length; i++) {
            array[i].selected = false;
            const children = array[i].children ? array[i].children : [];
            setDefaultSelected(children);
        }
    }
    setDefaultSelected(clone);

    const recursive = function (array: any[], id: string | number) {
        for (let i = 0; i < array.length; i++) {
            const node = array[i];
            if (node.id === id) {
                node.selected = true;
                return true;
            } else {
                const children = node.children ? node.children : [];
                const value = recursive(children, id);
                if (value === true) {
                    node.selected = true;
                    return true;
                }
            }
        }
        return false;
    }
    recursive(clone, id);
    return clone;
}

export const calculateTotalPage = (total: number, size: number) => {
    // CALCULATE TOTAL PAGES
    const totalPages = Math.ceil(total / size);
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }
    return pages;
}

export function getUri(url: any) {
    const m = (/ *^(?:([a-zA-Z0-9+.-]+):)?(\/\/(?:([^:@]*):([^:@]*)@)?([a-zA-Z0-9.-]+|\[[0-9a-zA-Z:]+\])(?::([0-9]+))?)?(\/?[^?#]*)?(?:\?([^#]*))?(?:#(.*))? */).exec(url);
    return {
        scheme: (m && m[1] && m[1].toLowerCase()) || '',
        user: (m && m[3]) || '',
        password: (m && m[4]) || '',
        domain: (m && m[5]) || '',
        port: (m && +m[6]) || -1,
        path: (m && m[7]) || '',
        query: (m && m[8]) || '',
        fragment: (m && m[9]) || ''
    };
}